function Dropdown({ children, testid }) {
  return (
    <div className="dropdown-container" data-testid={testid}>
      {children}
    </div>
  );
}

export default Dropdown;
